export default {
  name: "StandCountdownCpt",
  data() {
    return {
      timeObject: '',
      contentTxt: '',
      timer: ''
    };
  },
  props: {
    times: {
      // 倒计时间总秒数
      default: ''
    },
    isShowCountDown: {
      // 是否显示
      default: false
    }
  },
  watch: {
    times(value) {
      this.timeObject = this.formateTimeStamp(value);
      this.contentTxt = "倒计时：" + this.timeObject.day + "天" + this.timeObject.hour + "时" + this.timeObject.min + "分" + this.timeObject.seconds + "秒";
      // 这里如果不写一遍，页面上会有1秒左右的延迟才能看到倒计时
      this.countDowm(value);
    }
  },
  mounted() {// 倒计时间总秒数
  },
  methods: {
    countDowm(value) {
      var self = this;
      clearInterval(this.timer);
      this.timer = setInterval(function () {
        if (value > 0) {
          value -= 1;
          this.timeObject = self.formateTimeStamp(value);
          self.contentTxt = "倒计时：" + this.timeObject.day + "天" + this.timeObject.hour + "时" + this.timeObject.min + "分" + this.timeObject.seconds + "秒";
        } else {
          self.$emit('acountDown');
          clearInterval(this.timer);
        }
      }, 1000);
    },
    // formatNum (num) {
    //   return num < 10 ? '0' + num : '' + num
    // },
    formateTimeStamp(timeStamp) {
      var day;
      var hour;
      var min;
      var seconds;
      day = parseInt(timeStamp / (24 * 60 * 60)); // 计算整数天数
      var afterDay = timeStamp - day * 24 * 60 * 60; // 取得算出天数后剩余的秒数
      hour = parseInt(afterDay / (60 * 60)); // 计算整数小时数
      var afterHour = timeStamp - day * 24 * 60 * 60 - hour * 60 * 60; // 取得算出小时数后剩余的秒数
      min = parseInt(afterHour / 60); // 计算整数分
      seconds = parseInt(timeStamp - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60); // 取得算出分后剩余的秒数

      if (day < 10) {
        day = '0' + day;
      }
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (min < 10) {
        min = '0' + min;
      }
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      const restStamp = {
        day: day,
        hour: hour,
        min: min,
        seconds: seconds
      };
      return restStamp;
    }
  },
  computed: {}
};